import { render, staticRenderFns } from "./ThreeDSCompleteSetupPage.vue?vue&type=template&id=55513776&"
import script from "./ThreeDSCompleteSetupPage.vue?vue&type=script&lang=js&"
export * from "./ThreeDSCompleteSetupPage.vue?vue&type=script&lang=js&"
import style0 from "./ThreeDSCompleteSetupPage.vue?vue&type=style&index=0&id=55513776&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55513776')) {
      api.createRecord('55513776', component.options)
    } else {
      api.reload('55513776', component.options)
    }
    module.hot.accept("./ThreeDSCompleteSetupPage.vue?vue&type=template&id=55513776&", function () {
      api.rerender('55513776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ThreeDSCompleteSetupPage.vue"
export default component.exports